import 'scripts/vue/store/global'
import { px_breakpoints } from 'scripts/utils/breakpoints'
import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import VueScreen from 'vue-screen'
import { formatMoney } from '@shopify/theme-currency'
import * as images from '@shopify/theme-images'

/* config */
Vue.config.devtools = true
Vue.config.productionTip = false
Vue.config.silent = true

/* extensions */
Vue.prototype.$language = window.PSTheme.Language
Vue.prototype.$settings = window.PSTheme.Settings
Vue.prototype.$image = (src, size = '750x') => images.getSizedImageUrl(src, size)
Vue.prototype.$preloadImages = (imgArray, size = '750x') => images.preload(imgArray, size)
Vue.prototype.$money = amount => formatMoney(amount, '${{amount}}')
Vue.prototype.$isEmpty = obj => {
  if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true
}

/* plugins */
Vue.use(VueCompositionAPI)
Vue.use(VueScreen, {
  mobile_up   : px_breakpoints['--mobile-up'],
  tablet_up   : px_breakpoints['--tablet-up'],
  tablet_lg_up: px_breakpoints['--tablet-lg-up'],
  laptop_up   : px_breakpoints['--laptop-up'],
  desktop_up  : px_breakpoints['--desktop-up']
})
